// inbox/theme.js — لغة التصميم المنقولة حرفياً من CsInboxApp (البند 3).
export const C = {
  headerDark: "#F8F8FA",
  bgChat: "#FFFFFF",
  bubbleOut: "#0A84FF",
  bubbleIn: "#E9E9EB",
  textDark: "#1C1C1E",
  textMuted: "#8E8E93",
  accent: "#0A84FF",
  unread: "#0A84FF",
  waiting: "#FF9F0A",
  danger: "#dc2626",
  // جولة تصحيح 2026-10-14 (المرحلة 1) / البند 13/ز — tokens إضافية
  // (الألوان نفسها المستخدَمة أصلاً في الكود قبل هذه الجولة، مُجمَّعة هنا
  // فقط كمصدر وحيد بدل تكرار hex مباشر في كل ملف).
  white: "#FFFFFF",
  rowBg: "#f9fafb",
  border: "#e5e7eb",
  borderSoft: "#f0f2f5",
  successBg: "#DCFCE7", successText: "#166534",
  dangerBg: "#FEE2E2", dangerText: "#B91C1C", dangerBgSoft: "#FEF2F2",
  neutralBg: "#F3F4F6", neutralText: "#6B7280",
  warningBg: "#FFFBEB", warningText: "#92400E", warningBgSoft: "#FEF3C7",
  infoBg: "#EFF6FF", infoText: "#1D4ED8", infoBgSoft: "#DBEAFE",
  purpleBg: "#EDE9FE", purpleText: "#5B21B6",
  greenBgSoft: "#E7F5EC", greenTextSoft: "#1B5E20",
};

export const CATEGORY_META = {
  complaint: { label: "شكوى", color: "#dc2626", bg: "#fee2e2" },
  inquiry: { label: "استفسار", color: "#2563eb", bg: "#dbeafe" },
  question: { label: "سؤال", color: "#2563eb", bg: "#dbeafe" },
  praise: { label: "إشادة", color: "#059669", bg: "#d1fae5" },
  thanks_praise: { label: "شكر", color: "#059669", bg: "#d1fae5" },
  confirmation: { label: "تأكيد", color: "#16a34a", bg: "#dcfce7" },
  unsubscribe: { label: "إلغاء", color: "#6b7280", bg: "#f3f4f6" },
  suggestion: { label: "اقتراح", color: "#7c3aed", bg: "#ede9fe" },
  request: { label: "طلب", color: "#0f766e", bg: "#ccfbf1" },
  other: { label: "أخرى", color: "#92400e", bg: "#fef3c7" },
};

export const MODE_META = {
  off: { label: "موقوفة", color: "#6b7280", bg: "#f3f4f6" },
  shadow: { label: "وضع الظل", color: "#92400e", bg: "#fef3c7" },
  live: { label: "مباشر", color: "#065f46", bg: "#d1fae5" },
};

// إصلاح جولة 5A-fix (البند 4) — دالة عرض واحدة للرقم تُستخدم في كل مكان
// (القائمة + رأس المحادثة) بدل تكرار `+${phone}` في أكثر من مكوّن.
// إكمال الجولة C (2026-10-13، بند 4/و) — توحيد الصيغة مع القوائم (routes/
// customers_unified_list.py::_fmt_phone_05): 05XXXXXXXX محلياً، لا +966،
// بدل الصيغة الدولية +966XXXXXXXXX التي كانت تظهر هنا فقط دون القوائم.
export function displayPhone(phone) {
  const digits = String(phone || "").replace(/[^0-9]/g, "").trim();
  if (digits.startsWith("966") && digits.length === 12) {
    return "0" + digits.slice(3);
  }
  if (digits.startsWith("0") && digits.length === 10) {
    return digits;
  }
  return digits ? `+${digits}` : "";
}

export function initials(phone) {
  if (!phone) return "؟";
  return String(phone).replace(/[^0-9]/g, "").slice(-2);
}

export function colorForPhone(phone) {
  const palette = ["#075E54", "#1B5E20", "#283593", "#4527A0",
                   "#AD1457", "#BF360C", "#33691E", "#01579B"];
  let h = 0;
  for (const c of (phone || "")) h = (h * 31 + c.charCodeAt(0)) & 0xffff;
  return palette[h % palette.length];
}

export function timeOnly(iso) {
  if (!iso) return "";
  const t = String(iso).slice(11, 16);
  if (!t) return "";
  const [h, m] = t.split(":");
  const hKsa = (parseInt(h, 10) + 3) % 24;
  return `${String(hKsa).padStart(2, "0")}:${m}`;
}

// إصلاح جولة 5A-fix2 (البند 1) — z-index موحّد لكل نوافذ الصندوق، أعلى من
// أي طبقة عائمة أخرى في التطبيق (MobileSheet=10000 · toaster=9999) كي لا
// تُحجب النافذة خلف الترويسة أو الإشعارات بغضّ النظر عن مكان تركيبها.
export const Z_MODAL = 20000;
